module.exports = "/shiftTasks/components/taskTemplates/templatesList/emptyTaskTemplates-764784.html";